export default __webpack_public_path__ + "assets/images/button-video.c2322d622d4a110d015b984665d8be5a.svg";